import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';
import * as palette from 'common/shared/oldDocumentSignerUI/palette';

const styles = theme => ({
  fabProgress: {
    color: palette.success,
    position: 'absolute',
    zIndex: 1,
  },
});

const ProgressSpinner = props => {
  const { size, classes, top, left } = props;
  const dynamicStyles = {
    top,
    left,
  };
  return (
    <CircularProgress
      size={size}
      className={classes.fabProgress}
      style={dynamicStyles}
    />
  );
};

export default withStyles(styles)(ProgressSpinner);
